webpackJsonp([273315445554491],{

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _renderListItems = __webpack_require__(98);
	
	var _renderListItems2 = _interopRequireDefault(_renderListItems);
	
	var _GridLayout = __webpack_require__(547);
	
	var _GridLayout2 = _interopRequireDefault(_GridLayout);
	
	var _ProjectsListItem = __webpack_require__(509);
	
	var _ProjectsListItem2 = _interopRequireDefault(_ProjectsListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = _GridLayout2.default.withComponent('ul'); // -----------------------------------------------------------------------------
	// Articles List > View
	// -----------------------------------------------------------------------------
	
	var ProjectList = function ProjectList(_ref) {
	  var projects = _ref.projects;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    (0, _renderListItems2.default)(_ProjectsListItem2.default, 'project', projects)
	  );
	};
	
	ProjectList.propTypes = {
	  projects: _propTypes2.default.array.isRequired
	};
	
	exports.default = ProjectList;
	module.exports = exports['default'];

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['0 0 2.5ru'], ['0 0 2.5ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(250);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _markdown = __webpack_require__(22);
	
	var _HLayout = __webpack_require__(111);
	
	var _HLayout2 = _interopRequireDefault(_HLayout);
	
	var _VLayout = __webpack_require__(19);
	
	var _VLayout2 = _interopRequireDefault(_VLayout);
	
	var _TitleSecondary = __webpack_require__(119);
	
	var _TitleSecondary2 = _interopRequireDefault(_TitleSecondary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = (0, _styledComponents2.default)(_TitleSecondary2.default).withConfig({
	  displayName: 'ProjectsListItem__Title'
	})(['position:relative;font-weight:bold;']);
	
	var ImgLayout = _styledComponents2.default.div.withConfig({
	  displayName: 'ProjectsListItem__ImgLayout'
	})(['', ';'], (0, _cssapi.api)({
	  flex: (0, _cssapi.scope)(_templateObject)
	}));
	
	var TextLayout = (0, _styledComponents2.default)(_VLayout2.default).withConfig({
	  displayName: 'ProjectsListItem__TextLayout'
	})(['width:100%;']);
	
	var Layout = _styledComponents2.default.div.withConfig({
	  displayName: 'ProjectsListItem__Layout'
	})(['position:relative;']);
	
	var ProjectsListItem = function ProjectsListItem(_ref) {
	  var project = _ref.project;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      _HLayout2.default,
	      null,
	      _react2.default.createElement(
	        ImgLayout,
	        null,
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: (0, _markdown.frontmatterImageSizes)(project) })
	      ),
	      _react2.default.createElement(
	        TextLayout,
	        { spacing: 'small' },
	        _react2.default.createElement(
	          Title,
	          null,
	          (0, _markdown.fieldsTitle)(project)
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          project.excerpt
	        )
	      )
	    )
	  );
	};
	
	ProjectsListItem.propTypes = {
	  project: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProjectsListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProjectList = __webpack_require__(508);
	
	var _ProjectList2 = _interopRequireDefault(_ProjectList);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ProjectList2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formatting = __webpack_require__(49);
	
	var _markdown = __webpack_require__(22);
	
	var _siteMetadata = __webpack_require__(72);
	
	var _Metadata = __webpack_require__(73);
	
	var _Metadata2 = _interopRequireDefault(_Metadata);
	
	var _Page = __webpack_require__(108);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ProjectsList = __webpack_require__(510);
	
	var _ProjectsList2 = _interopRequireDefault(_ProjectsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectsPage = function ProjectsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _Page2.default,
	    { title: (0, _formatting.pluralise)((0, _siteMetadata.projectsResourceTitle)(data)) },
	    _react2.default.createElement(_Metadata2.default, (0, _siteMetadata.projectsPageMetadata)(data)),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Over the years, I\'ve worked on a wide variety of technologies and platforms, but always with an emphasis on data visualisation, media-rich, interactive and realtime applications. Here are some examples.'
	    ),
	    _react2.default.createElement(_ProjectsList2.default, { projects: (0, _markdown.markdownItemNodes)(data) })
	  );
	};
	
	ProjectsPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = ProjectsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProjectsPage = __webpack_require__(511);
	
	var _ProjectsPage2 = _interopRequireDefault(_ProjectsPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ProjectsPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _width;
	
	var _templateObject = _taggedTemplateLiteralLoose(['1ru'], ['1ru']);
	
	var _cssapi = __webpack_require__(4);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _flexHorizontal = __webpack_require__(54);
	
	var _flexHorizontal2 = _interopRequireDefault(_flexHorizontal);
	
	var _uiList = __webpack_require__(164);
	
	var _uiList2 = _interopRequireDefault(_uiList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var GridLayout = _styledComponents2.default.div.withConfig({
	  displayName: 'GridLayout'
	})(['', ';', ';flex-wrap:wrap;justify-content:space-between;& > *{', ';}'], _flexHorizontal2.default, _uiList2.default, (0, _cssapi.api)({
	  width: (_width = { default: '100%' }, _width['mediumUp-200'] = 'calc(50% - 0.5ru)', _width),
	  marginBottom: (0, _cssapi.scope)(_templateObject)
	}));
	
	exports.default = GridLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['', ''], ['', '']);
	
	var _cssapi = __webpack_require__(4);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(3);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _flexHorizontal = __webpack_require__(54);
	
	var _flexHorizontal2 = _interopRequireDefault(_flexHorizontal);
	
	var _spaceChildrenH = __webpack_require__(55);
	
	var _spaceChildrenH2 = _interopRequireDefault(_spaceChildrenH);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var spacingMap = {
	  default: '1ru',
	  tiny: '0.25ru',
	  small: '0.5ru',
	  large: '2ru',
	  smallInverse: '-0.5ru',
	  none: 0
	};
	
	var HLayout = _styledComponents2.default.div.withConfig({
	  displayName: 'HLayout'
	})(['', ';', ';'], _flexHorizontal2.default, function (p) {
	  return (0, _spaceChildrenH2.default)((0, _cssapi.scope)(_templateObject, spacingMap[p.spacing]))(p);
	});
	
	HLayout.propTypes = {
	  spacing: _propTypes2.default.oneOf(['default', 'small', 'large', 'smallInverse', 'space', 'tiny', 'none'])
	};
	
	HLayout.defaultProps = {
	  spacing: 'default'
	};
	
	exports.default = HLayout;
	module.exports = exports['default'];

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _graphql = __webpack_require__(58);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _ProjectsPage = __webpack_require__(512);
	
	var _ProjectsPage2 = _interopRequireDefault(_ProjectsPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ProjectsPage2.default;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-templates-projects-js-01fb08cf41b6de67558e.js